import React, { useEffect } from "react";
import { Layout, Typography } from "antd";
import { useRoutes } from "react-router-dom";
import routes from "../../Routes";
import "./Dashboard.scss";

const { Title } = Typography;
const { Header, Content, Footer } = Layout;
export function getFirstRegisterValue(value) {
  sessionStorage.setItem("register1", JSON.stringify(value));
}

export function getSecondRegisterValue(value) {
  sessionStorage.setItem("register2", JSON.stringify(value));
}

export default function Dashboard() {
  useEffect(() => {
    document.title = "新東陽會員";
  }, []);
  let element = useRoutes(routes);
  return (
    <>
      <Layout className="background-base">
        <Header>
          <Title level={3} className="left-border-title"></Title>
        </Header>
        <Content>
          <div className="component-wrapper">
            {/* components should put here. */}
            {element}
          </div>
        </Content>
        <Footer />
      </Layout>
    </>
  );
}
